import styled from "styled-components";
import {
  Colors,
  GrayColors,
  SolutionColorVariables,
  TextColorNames,
} from "@smartsuite/types";
import type { PartialBadgeStylesType } from "@smartsuite/react-ui/lib";
import { TextSizes } from "@smartsuite/react-ui/lib";

interface IIntegrationLabel {
  fontSize: string;
  color: string;
  paddingLeft: string;
  textAlign: "left" | "center" | "right";
}

export const IntegrationLabel = styled.span<Partial<IIntegrationLabel>>`
  width: 100%;
  padding-left: ${({ paddingLeft }) => paddingLeft};
  text-align: ${({ textAlign }) => textAlign};
  color: ${({ color }) => color};
`;

IntegrationLabel.defaultProps = {
  paddingLeft: "10px",
  textAlign: "left",
  color: GrayColors["G-8"],
  fontSize: ".9em",
};

export const MenuOptionWrapper = styled.div`
  border-radius: 4px;

  .submenu-item {
    display: flex;
    min-width: 350px;
  }

  .menu-option {
    &__container {
      width: 100%;
    }
  }
`;

export const MenuOptionList = styled.div`
  .menu-option {
    color: ${TextColorNames.tertiary};

    &:hover {
      color: ${TextColorNames.primary};
    }
  }
`;

export const StyledTriggerRequest = styled.div`
  padding: 0 20px 5px;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  color: ${TextColorNames.secondary};

  button {
    color: ${SolutionColorVariables.sc1};
    cursor: pointer;
    text-decoration: none;
    transition: color 200ms ease;

    &:hover {
      color: ${SolutionColorVariables.sc3};
    }
  }
`;

export const BetaWrapper = styled.span`
  margin-left: 10px;
`;

export const betaStyle: PartialBadgeStylesType = {
  background: Colors.dwYellow,
  textColor: TextColorNames.tertiary,
  textSize: TextSizes.XXXS,
  borderRadius: 10,
  sidePadding: 7,
  textWeight: "regular",
  height: 17,
};

export const commingSoonStyle: PartialBadgeStylesType = {
  background: Colors.custom16,
  textColor: TextColorNames.white,
  textSize: TextSizes.XXXS,
  borderRadius: 10,
  sidePadding: 7,
  textWeight: "regular",
  height: 17,
};
